// Campus photo for /colleges/california-institute-of-technology: CC BY 1.0, by Geographer, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3ABeckman_auditorium%2C_Caltech.jpg), checked 2026-10-01 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/california-institute-of-technology/; credited under the photo.
const photo = {
    "slug": "california-institute-of-technology",
    "alt": "Beckman Auditorium and its lawn, with the San Gabriel Mountains behind, at Caltech in Pasadena, California",
    "src": "/colleges/california-institute-of-technology/campus-1600.webp",
    "srcSmall": "/colleges/california-institute-of-technology/campus-800.webp",
    "srcMid": "/colleges/california-institute-of-technology/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/california-institute-of-technology/og.jpg",
    "title": "Beckman auditorium, Caltech",
    "author": "Geographer",
    "license": "CC BY 1.0",
    "licenseUrl": "https://creativecommons.org/licenses/by/1.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3ABeckman_auditorium%2C_Caltech.jpg",
    "read": "2026-10-01"
};

export default photo;
